import cn from 'classnames';

import { SkuT } from '@lambda/apis/src/catalog-v2/types';
import Wrapper from './Wrapper';
import DealCard from '@/components/v2/common/card/DealCard';

const Spotlight = ({ skus }: { skus: SkuT[] }) => {
  if (skus.length < 4) {
    return null;
  }

  return (
    <Wrapper>
      <div className="flex flex-col gap-3 px-3 pb-3 3xs:grid 3xs:grid-cols-2 md:grid-cols-3 md:px-5 md:pb-5 lg:grid-cols-4 xl:grid-cols-5">
        {skus?.map((sku, index) => (
          <div className={cn({ '3xs:col-span-2': index === 0 })} key={sku.id}>
            <DealCard isHighlighted={index === 0} sku={sku} />
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default Spotlight;
